import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { PERIOD as period } from '@constants/billing';
import styled from 'styled-components';

import { DiscountChip, StyledBox, StyledStack, StyledStackContainer, StyledTypography } from './styled';
import { useTheme } from '@/components/theme-v2/ThemeContext';
import { ToggleProps } from '@/shared/types';

const ToggleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 16px;
`;

const Toggle: FC<ToggleProps> = ({ active, setActive, isMobile }) => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';

  return (
    <ToggleWrapper>
      <StyledStackContainer $width={isMobile ? '360px' : '440px'} $height="50px" $isDark={isDarkMode}>
        <StyledStack $width="50%" onClick={() => setActive(period.month)}>
          <StyledTypography $isActive={active === period.month} $isDark={isDarkMode}>
            {t('billing.period.month')}
          </StyledTypography>
        </StyledStack>
        <StyledStack $width="50%" onClick={() => setActive(period.year)}>
          <StyledTypography $isActive={active === period.year} $isDark={isDarkMode}>
            {t('billing.period.year')}
          </StyledTypography>
          <DiscountChip $isActive={active === period.year}>Save 20%</DiscountChip>
        </StyledStack>
        <StyledBox $active={active} $isMobile={isMobile} />
      </StyledStackContainer>
    </ToggleWrapper>
  );
};

export default memo(Toggle);
